import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="set-cookie"
export default class extends Controller {
  static values = {
    name: String,
    expiresInHours: { type: Number, default: 24 }
  }

  set() {
    const expires = new Date()
    expires.setTime(expires.getTime() + this.expiresInHoursValue * 60 * 60 * 1000)

    document.cookie = `${this.nameValue}=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax`
  }
}
